import { useEffect, useState } from "react";
import UserImage from "../../images/captify-user.jpg";

export default function UserAvatar({
  src,
  size = 36,
  alt = "User",
  className = "",
  roundedClassName = "rounded-circle",
}) {
  const [imgSrc, setImgSrc] = useState(src || UserImage);

  useEffect(() => {
    setImgSrc(src || UserImage);
  }, [src]);

  return (
    <img
      src={imgSrc}
      alt={alt}
      width={size}
      height={size}
      style={{ minWidth: size, minHeight: size }}
      className={`user-avatar object-fit-cover flex-shrink-0 ${roundedClassName} ${className}`.trim()}
      referrerPolicy="no-referrer"
      onError={() => {
        if (imgSrc !== UserImage) {
          setImgSrc(UserImage);
        }
      }}
    />
  );
}
